// extracted by mini-css-extract-plugin
export default {"aISaasLogo":"Header_aISaasLogo__NZEM2","outputWrapper":"Header_outputWrapper__aDSpx","footerWrapper":"Header_footerWrapper__g+mwJ"};